module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "navigation-section"
  }, [_c('div', {
    staticClass: "navigation-overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "navigation-and-offcanvas"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('a', {
    staticClass: "c-nav__close-button w-inline-block",
    attrs: {
      "data-w-id": "19441b04-6667-8112-1ac3-50ce8ef78c8b",
      "href": "#"
    },
    on: {
      "click": _vm.hbo_c
    }
  }, [_vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "navigation-and-offcanvas",
    attrs: {
      "id": "nav_k_mobile"
    }
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('a', {
    staticClass: "c-nav__close-button w-inline-block",
    attrs: {
      "data-w-id": "19441b04-6667-8112-1ac3-50ce8ef78c8b",
      "href": "#"
    },
    on: {
      "click": _vm.hbo_c
    }
  }, [_vm._m(7)])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-navigation-bar"
  }, [_vm._m(8), _vm._v(" "), _c('a', {
    staticClass: "burger-button w-inline-block",
    attrs: {
      "data-w-id": "19441b04-6667-8112-1ac3-50ce8ef78c92",
      "href": "#"
    },
    on: {
      "click": _vm.hbo
    }
  }, [_vm._m(9)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col lg-2 md-basis-auto md-order-first no-margin-bottom-lg"
  }, [_c('a', {
    staticClass: "brand justify-left w-inline-block w--current",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logo.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col no-margin-bottom lg-8 md-basis-auto md-order-last"
  }, [_c('nav', {
    staticClass: "navigation-menu flexh-justify-center position-relative md-margin-top"
  }, [_c('a', {
    staticClass: "nav-link on-dark w--current",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('a', {
    staticClass: "nav-link on-dark",
    attrs: {
      "href": "/shops"
    }
  }, [_vm._v("Shop")]), _vm._v(" "), _c('a', {
    staticClass: "nav-link on-dark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Events")]), _vm._v(" "), _c('a', {
    staticClass: "nav-link on-dark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col no-margin-bottom lg-2 lg-text-align-right md-basis-auto"
  }, [_c('div', {
    staticClass: "inline-block position-relative"
  }, [_c('a', {
    staticClass: "c-navbar-icon is-brand-color on-dark",
    attrs: {
      "data-w-id": "19441b04-6667-8112-1ac3-50ce8ef78c54",
      "href": "#"
    }
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "c-search-popup w-form"
  }, [_c('form', {
    attrs: {
      "id": "wf-form-Search",
      "name": "wf-form-Search",
      "data-name": "Search"
    }
  }, [_c('input', {
    staticClass: "form-input-text w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "Search-2",
      "data-name": "Search 2",
      "placeholder": "Search product",
      "id": "Search-2"
    }
  })])])]), _c('a', {
    staticClass: "c-navbar-icon is-19px on-dark",
    attrs: {
      "href": "/account"
    }
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "c-cart",
    attrs: {
      "data-w-id": "19441b04-6667-8112-1ac3-50ce8ef78c65"
    }
  }, [_c('a', {
    staticClass: "c-navbar-icon on-dark",
    attrs: {
      "href": "/cart"
    }
  }, [_vm._v("")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iconfont is-offcanvas-close-button"
  }, [_c('em', {
    staticClass: "iconfont__no-italize"
  }, [_vm._v("")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col lg-2 md-basis-auto md-order-first no-margin-bottom-lg"
  }, [_c('a', {
    staticClass: "brand justify-left w-inline-block w--current",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logo.png",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col no-margin-bottom lg-8 md-basis-auto md-order-last"
  }, [_c('nav', {
    staticClass: "navigation-menu flexh-justify-center position-relative md-margin-top"
  }, [_c('a', {
    staticClass: "nav-link on-dark w--current",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('a', {
    staticClass: "nav-link on-dark",
    attrs: {
      "href": "/shops"
    }
  }, [_vm._v("Shop")]), _vm._v(" "), _c('a', {
    staticClass: "nav-link on-dark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Events")]), _vm._v(" "), _c('a', {
    staticClass: "nav-link on-dark",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col no-margin-bottom lg-2 lg-text-align-right md-basis-auto"
  }, [_c('div', {
    staticClass: "inline-block position-relative"
  }, [_c('a', {
    staticClass: "c-navbar-icon is-brand-color on-dark",
    attrs: {
      "data-w-id": "19441b04-6667-8112-1ac3-50ce8ef78c54",
      "href": "#"
    }
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "c-search-popup w-form"
  }, [_c('form', {
    attrs: {
      "id": "wf-form-Search",
      "name": "wf-form-Search",
      "data-name": "Search"
    }
  }, [_c('input', {
    staticClass: "form-input-text w-input",
    attrs: {
      "type": "text",
      "maxlength": "256",
      "name": "Search-2",
      "data-name": "Search 2",
      "placeholder": "Search product",
      "id": "Search-2"
    }
  })])])]), _c('a', {
    staticClass: "c-navbar-icon is-19px on-dark",
    attrs: {
      "href": "account"
    }
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "c-cart",
    attrs: {
      "data-w-id": "19441b04-6667-8112-1ac3-50ce8ef78c65"
    }
  }, [_c('a', {
    staticClass: "c-navbar-icon on-dark",
    attrs: {
      "href": "cart"
    }
  }, [_vm._v("")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iconfont is-offcanvas-close-button"
  }, [_c('em', {
    staticClass: "iconfont__no-italize"
  }, [_vm._v("")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "brand w-inline-block",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": "/static/assets/images/logo-black.png",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iconfont is-burger"
  }, [_c('em', {
    staticClass: "iconfont__no-italize"
  }, [_vm._v("")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d8bed0a"}!./src/pages/MainHeader/template.html
// module id = 238
// module chunks = 0